import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    checkedProjects: (state, action) => {
      const { project, checked } = action.payload;
      const existingProject = state.find((p) => p.id === project.id);
      
      if (existingProject) {
        existingProject.checked = checked;
      } else {
        state.push({ project, checked, id: project.id });
      }
    },
  },
});
// eslint-disable-next-line
export const { checkedProjects } = projectsSlice.actions;
export default projectsSlice.reducer;
